<template>
  <div class="select_dialog_embed">
    <div class="order_import_embed_msg">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content text_center">
          <p class="mt30 mb30">{{errorTxt}}是否下载上传信息结果？</p>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom pb20">
          <button class="btn_normal" @click="downloadUploadMsg()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(false)">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'order-import-embed-msg',
    props: ['title', 'showType', 'msg', 'errorTxt'],
    data() {
      return {

      }
    },
    methods: {
      // 下载上传结果
      downloadUploadMsg() {
        this.cancelBtn(true);
        window.open(this.msg, '_blank');
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
      }
    },
    created() {
      console.log(this.msg);
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .order_import_embed_msg {
    background-color: #fff;
    max-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/order-import-embed-msg.vue